import { PharmacyTheme } from '../PharmacyThemeInterface';
import pic from './assets/veritas_slider2.jpg';

export const secTestCustomisations: Partial<PharmacyTheme> = {
  panoramaPic: pic,
};
